import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Logo from '../images/Logo.png';

const Login = () => {
    const email = React.useRef();
    const password = React.useRef();
    const [isFetching, setIsFetching] = React.useState(false);

    const handleClick = async (e) => {
        e.preventDefault();
        setIsFetching(true);

        const user = {
            email: email.current.value,
            password: password.current.value,
        };

        try {
            const res = await axios.post("http://localhost:5050/db/login", user);
            if (res.data) {
                // Redirect to home page after successful login
                const encodedEmail = encodeURIComponent(email.current.value);
                window.location.replace(`/?email=${encodedEmail}`);
            }
        } catch (err) {
            console.error("Login failed:", err.response ? err.response.data : err.message);
            alert(err.response?.data?.error || "An error occurred during login. Please try again.");
        } finally {
            setIsFetching(false);
        }
    };

    return (
        <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                <img
                    className="mx-auto h-10 w-auto"
                    src={Logo}
                    alt="Logo"
                />
                <h2 className="mt-10 text-center text-2xl font-bold tracking-tight text-gray-900">
                   Login to your account
                </h2>
            </div>

            <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
                <form className="space-y-6" onSubmit={handleClick}>
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-900">
                            Email address
                        </label>
                        <div className="mt-2">
                            <input
                                id="email"
                                name="email"
                                type="email"
                                autoComplete="email"
                                required
                                ref={email}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm"
                            />
                        </div>
                    </div>

                    <div>
                        <label htmlFor="password" className="block text-sm font-medium text-gray-900">
                            Password
                        </label>
                        <div className="mt-2">
                            <input
                                id="password"
                                name="password"
                                type="password"
                                autoComplete="current-password"
                                required
                                ref={password}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm"
                            />
                        </div>
                    </div>

                    <div>
                        <button
                            type="submit"
                            className="flex w-full justify-center rounded-md bg-sky-600 px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-sky-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600"
                            disabled={isFetching}
                        >
                            {isFetching ? "Logging in..." : "Login"}
                        </button>
                    </div>
                </form>

                <p className="mt-10 text-center text-sm text-gray-500">
                    Not registered?{' '}
                    <Link to="/signup" className="font-semibold text-indigo-600 hover:text-indigo-500">
                        Sign up
                    </Link>
                </p>
            </div>
        </div>
    );
};

export default Login;
